<script>
import ListForm from "../ListForm.vue";
import * as categoryService from "../../service/category.service";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  components: {
    ListForm,
  },
  data() {
    return {
      value: null,
      listData: new Array(),
      selectedItem: new Object(),
      prevSelectedItem: "{}",
      showListForm: false,
    };
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x) => x.active == true).length;
    },
    filteredList() {
      let list = this.listData.filter(
        (x) =>
          x.additionalProp1 &&
          x.additionalProp1[this.item.filterOn] &&
          x.additionalProp1[this.item.filterOn] == this.value
      );
      return list;
    },
  },
  watch: {
    topbarControls: {
      handler: function (val) {
        if (
          val.title == "Quick Links" ||
          val.title == "Conditions" ||
          val.title == "Recommended Apps" ||
          val.title == "Banners" ||
          val.title == "Manage My Conditions" ||
          val.title == "Join the Practice" ||
          val.title == "Prescriptions" ||
          val.title == "Sick/Fit Notes" ||
          val.title == "Carer Information" ||
          val.title == "Patient Group" ||
          val.title == "Practice Information" ||
          val.title == "PCN Information" ||
          val.title == "Manage Conditions" ||
          val.title == "About Us" ||
          val.title == "Health And Wellbeing" ||
          val.title == "Landing Page"
        ) {
          if (this.selectedItem && this.selectedItem.id) {
            if (val.selectedItem.id != this.selectedItem.id) {
              this.selectedItem = val.selectedItem;
            }
            if (!val.listItems.length) {
              this.listData = [];
              this.setSelectedItems(new Object());
            }
            if (
              !this.listData.filter((x) => x.id == val.selectedItem.id).length
            ) {
              this.setSelectedItems(this.listData[0]);
            }
          } else if (
            !Object.keys(this.selectedItem).length &&
            val.selectedItem &&
            Object.keys(val.selectedItem).length
          ) {
            this.selectedItem = val.selectedItem;
          }
          if (
            this.listData &&
            val.listItems &&
            this.listData.length == val.listItems.length + 1
          ) {
            this.listData = val.listItems;
          } else {
            if (val.listItems && this.listData != val.listItems) {
              let list = this.listData;
              val.listItems.forEach((element) => {
                list = list.filter((x) => x.id != element.id);
                list.push(element);
              });
              this.listData = list;
            }
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    setSelectedItems(val) {
      if (val) {
        this.selectedItem = val;
        this.prevSelectedItem = JSON.stringify(val);
        this.setTopbarControls(
          null,
          this.listData,
          this.selectedItem,
          this.prevSelectedItem
        );
      }
    },
    setListItems(val, sort) {
      if (sort)
        this.listData = val.sort(
          (a, b) => a.additionalProp1.position - b.additionalProp1.position
        );
      else this.listData = val;
      if (this.listData.length) {
        this.setSelectedItems(this.listData[0]);
      } else {
        this.setSelectedItems(new Object());
      }
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      const data = await categoryService.getPages(
        this.$route.params.categoryId
      );
      this.setListItems(data, true);
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>
<template>
  <ListForm
    :style="item.style"
    :class="`col-${item.size} ${item.class}`"
    :item="item"
    :items="item.children"
    :selectedItem="selectedItem"
    :listItems="listData"
    :prevSelectedItem="prevSelectedItem"
    :setSelectedItems="setSelectedItems"
    :topbarControls="topbarControls"
  />
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
